(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-material-help"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-ke-material-help]');
  const panel = document.querySelector('#KeMaterialPopover');
  if (!config || !panel || panel.dataset.ready) return;
  panel.dataset.ready = 'true';
  document.body.append(panel);
  const content = panel.querySelector('[data-ke-help-content]');
  const closeButton = panel.querySelector('button');
  const label = config.querySelector('[data-ke-help-label]').textContent;
  const valid = ['P', 'M', 'K', 'N', 'S', 'H'];
  let active = null;

  function position() {
    if (!active || panel.hidden) return;
    const anchor = active.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;
    panel.style.maxWidth = `${viewportWidth - 24}px`;
    const width = panel.offsetWidth, height = panel.offsetHeight;
    const x = Math.max(12, Math.min(anchor.left, viewportWidth - width - 12));
    const y = anchor.bottom + height + 12 <= viewportHeight ? anchor.bottom + 10 : anchor.top - height - 10;
    panel.style.left = `${x}px`;
    panel.style.top = `${Math.max(12, Math.min(y, viewportHeight - height - 12))}px`;
  }

  function close(restore = false) {
    const previous = active;
    const returnFocus = restore || panel.contains(document.activeElement);
    if (previous) {
      previous.removeAttribute('aria-describedby');
      if (previous.tagName === 'BUTTON') previous.setAttribute('aria-expanded', 'false');
    }
    active = null;
    panel.hidden = true;
    if (returnFocus && previous?.isConnected) {
      previous.focus({ preventScroll: true });
    }
  }

  function show(trigger) {
    const template = config.querySelector(`[data-ke-material-content="${trigger.dataset.keMaterial}"]`);
    if (!template) return;
    close();
    active = trigger;
    content.replaceChildren(template.content.cloneNode(true));
    panel.dataset.group = trigger.dataset.keMaterial;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-labelledby', 'KeMaterialTitle');
    panel.hidden = false;
    trigger.setAttribute('aria-describedby', panel.id);
    if (trigger.tagName === 'BUTTON') trigger.setAttribute('aria-expanded', 'true');
    position();
    closeButton.focus({ preventScroll: true });
  }

  function bind(trigger, code) {
    if (trigger.dataset.keMaterial) return;
    trigger.dataset.keMaterial = code;
    trigger.setAttribute('aria-label', `${label} ${code}`);
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.addEventListener('click', () => {
      if (active === trigger) close(true);
      else show(trigger);
    });
  }

  function decorate() {
    document.querySelectorAll('.kiso:not([data-ke-help-ready])').forEach(badge => {
      const code = valid.find(value => badge.classList.contains(`kiso--${value.toLowerCase()}`));
      badge.dataset.keHelpReady = 'true';
      if (!code) return;
      badge.removeAttribute('title');
      const link = badge.closest('a');
      if (link) {
        if (link.matches('[data-iso-filter]')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'ke-material-option';
          link.before(wrapper);
          wrapper.append(link);
          const info = document.createElement('button');
          info.type = 'button';
          info.className = 'ke-material-info';
          const mark = document.createElement('span');
          mark.textContent = 'i';
          mark.setAttribute('aria-hidden', 'true');
          info.append(mark);
          wrapper.append(info);
          bind(info, code);
        }
      } else {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `${badge.className} ke-material-icon`;
        button.dataset.keHelpReady = 'true';
        button.textContent = code;
        badge.replaceWith(button);
        bind(button, code);
      }
    });
  }

  closeButton.addEventListener('click', () => close(true));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
  });
  document.addEventListener('pointerdown', event => {
    if (active && !panel.contains(event.target) && !active.contains(event.target)) close();
  });
  document.addEventListener('focusin', event => {
    if (active && !panel.contains(event.target) && !active.contains(event.target)) close();
  });
  document.addEventListener('scroll', event => {
    if (active && !panel.contains(event.target)) close();
  }, true);
  window.addEventListener('resize', () => close());
  window.addEventListener('pagehide', () => close());
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; decorate(); });
  });
  function init() {
    decorate();
    const main = document.querySelector('main');
    if (main) observer.observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ke-product-image-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ke-product-image-gallery')) {
    customElements.define('ke-product-image-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('.ke-gallery-thumbnail');
          if (!thumbnail || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const link = this.querySelector('.ke-gallery-main');
          const image = link.querySelector('img');
          event.preventDefault();
          image.removeAttribute('srcset');
          image.src = thumbnail.dataset.imageSrc;
          image.alt = thumbnail.dataset.imageAlt;
          image.width = Number(thumbnail.dataset.imageWidth);
          image.height = Number(thumbnail.dataset.imageHeight);
          link.href = thumbnail.href;
          this.querySelectorAll('.ke-gallery-thumbnail').forEach(item => item.removeAttribute('aria-current'));
          thumbnail.setAttribute('aria-current', 'true');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ke-ux-enhancements"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.body.dataset.keReady = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const compactFilters = window.matchMedia('(max-width: 1024px)');
    const menuButton = document.querySelector('.ke-menu-toggle');
    const links = document.getElementById('KetoolsNavLinks');
    if (menuButton && links && !menuButton.dataset.bound) {
      menuButton.dataset.bound = 'true';
      const closeMenu = () => { links.classList.remove('is-open'); menuButton.setAttribute('aria-expanded', 'false'); };
      menuButton.addEventListener('click', () => {
        const open = links.classList.toggle('is-open');
        menuButton.setAttribute('aria-expanded', String(open));
      });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && links.classList.contains('is-open')) { closeMenu(); menuButton.focus(); } });
      mobile.addEventListener('change', closeMenu);
    }
    document.querySelectorAll('[data-ke-responsive-details]').forEach(panel => {
      if (panel.dataset.keBound) return;
      panel.dataset.keBound = 'true';
      const viewport = panel.classList.contains('ke-filter-panel') ? compactFilters : mobile;
      panel.open = !viewport.matches;
      viewport.addEventListener('change', e => { panel.open = !e.matches; });
    });
    document.querySelectorAll('[data-ke-show-results]').forEach(button => {
      if (button.dataset.keBound) return;
      button.dataset.keBound = 'true';
      button.addEventListener('click', () => {
        const panel = button.closest('details');
        if (panel) panel.open = false;
        document.getElementById('ke-results')?.focus({preventScroll:true});
      });
    });
    document.querySelectorAll('.kbrw').forEach(root => {
      if (root.dataset.keBound) return;
      root.dataset.keBound = 'true';
      const table = root.querySelector('.kbrw-table');
      const field = root.querySelector('[data-kbrw-filter]');
      const container = root.querySelector('[data-ke-dimensions]');
      if (!table || !field || !container) return;
      const rows = [...table.querySelectorAll('[data-kbrw-row]')];
      const headers = [...table.querySelectorAll('thead th')];
      const selects = [];
      for (let index = 1; index <= Math.min(3, headers.length - 4); index++) {
        const values = [...new Set(rows.map(row => row.children[index]?.textContent.trim()).filter(Boolean))];
        if (values.length < 2) continue;
        values.sort((a,b) => a.localeCompare(b, document.documentElement.lang, {numeric:true}));
        const label = document.createElement('label');
        const caption = document.createElement('span');
        caption.textContent = headers[index].dataset.mobileLabel || headers[index].textContent.trim();
        const select = document.createElement('select');
        select.dataset.index = String(index);
        const all = document.createElement('option'); all.value = ''; all.textContent = root.dataset.keAll; select.append(all);
        values.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; select.append(option); });
        label.append(caption,select);
        (index === 1 ? root.querySelector('[data-ke-primary-dimension]') : container).append(label); selects.push(select);
      }
      const apply = () => {
        const query = field.value.trim().toLocaleLowerCase();
        let count = 0;
        rows.forEach(row => {
          const textMatch = !query || (row.dataset.search || '').toLocaleLowerCase().includes(query);
          const dimensionMatch = selects.every(select => !select.value || row.children[Number(select.dataset.index)]?.textContent.trim() === select.value);
          row.hidden = !(textMatch && dimensionMatch);
          if (!row.hidden) count++;
        });
        root.querySelectorAll('[data-kbrw-count]').forEach(el => el.textContent = String(count));
        const empty = root.querySelector('[data-ke-no-variants]'); if (empty) empty.hidden = count !== 0;
        const active = selects.filter(select => select.value).length + (query ? 1 : 0);
        root.querySelector('[data-ke-reset-variants]').hidden = active === 0;
        const advancedCount = selects.filter(select => select.dataset.index !== '1' && select.value).length + (query ? 1 : 0);
        const badge = root.querySelector('[data-ke-extra-count]');
        badge.textContent = advancedCount ? `(${advancedCount})` : '';
        selects.forEach(select => [...select.options].forEach(option => {
          if (!option.value || option.selected) { option.disabled = false; return; }
          option.disabled = !rows.some(row => (!query || (row.dataset.search || '').toLocaleLowerCase().includes(query)) &&
            row.children[Number(select.dataset.index)]?.textContent.trim() === option.value &&
            selects.every(other => other === select || !other.value || row.children[Number(other.dataset.index)]?.textContent.trim() === other.value));
        }));
      };
      field.addEventListener('input',apply);
      selects.forEach(select => select.addEventListener('change',apply));
      root.querySelector('[data-ke-reset-variants]')?.addEventListener('click', () => { field.value = ''; selects.forEach(select => select.value = ''); apply(); });
      root.querySelectorAll('.ke-variant-toggle').forEach(button => button.addEventListener('click', () => {
        const row = button.closest('tr'); const expanded = row.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded',String(expanded)); button.textContent = expanded ? root.dataset.keHide : root.dataset.keShow;
      }));
      const count = root.querySelector('[data-kbrw-count]'); if (count) { count.parentElement.setAttribute('aria-live','polite'); count.parentElement.setAttribute('aria-atomic','true'); }
      apply();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(initialize), {once:true});
  else requestAnimationFrame(initialize);
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(initialize));
})();
  } catch(e) { console.error(e); }
})();

})();
